import { Bert } from 'meteor/themeteorchef:bert';

export default error => {
  if (Object.prototype.hasOwnProperty.call(error, 'message')) {
    Bert.alert(error.message, 'danger');
  } else if (Object.prototype.hasOwnProperty.call(error, 'reason')) {
    Bert.alert(error.reason, 'danger');
  } else {
    Bert.alert(JSON.stringify(error), 'danger');
  }
};
